import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["id", "limit", "maxLength", "loadMore"],
  _excluded2 = ["data"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Card from "@/components/Card/index";
import Grid from "@/components/Grid";
import { usePaletteQuery } from "@/hooks";
import { GRID_PAGE_LIMIT } from "@/lib/constants";
import { useMemo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export default function PaletteGrid(_ref) {
  let {
      id,
      limit = GRID_PAGE_LIMIT,
      maxLength,
      loadMore = true
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  if (maxLength && limit > maxLength) {
    limit = maxLength;
  }
  const _usePaletteQuery = usePaletteQuery({
      variables: {
        id,
        offset: 0,
        limit
      },
      nextFetchPolicy: "cache-first"
    }),
    {
      data
    } = _usePaletteQuery,
    result = _objectWithoutProperties(_usePaletteQuery, _excluded2);
  const palette = data === null || data === void 0 ? void 0 : data.palette;
  const paletteObjects = data === null || data === void 0 ? void 0 : data.paletteObjects;
  const items = useMemo(() => {
    if (paletteObjects) {
      return {
        data: paletteObjects.data.map(obj => obj.meta || obj.advertising),
        pageInfo: paletteObjects.pageInfo
      };
    } else {
      return null;
    }
  }, [paletteObjects]);
  return /*#__PURE__*/_jsx(Grid, _objectSpread(_objectSpread({
    header: {
      text: palette === null || palette === void 0 ? void 0 : palette.header,
      main: true
    },
    viewTypeClassName: "grid",
    itemComponent: Card,
    items: items
  }, result), {}, {
    limit,
    maxLength,
    loadMore
  }, props));
}